import React from 'react';
import defaults from '../../translations/en.json';

export const MessageOverlay = () => (
  <div className="ag-overlay-loading-center">
    <span>{defaults.saving}</span>
  </div>
);

export default MessageOverlay;
